var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_144_8186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9042 6.50441C22.6417 5.51691 21.8708 4.74191 20.8917 4.47941C19.1167 4.00024 12 4.00024 12 4.00024C12 4.00024 4.88335 4.00024 3.10835 4.47941C2.12918 4.74191 1.35835 5.51691 1.09585 6.50441C0.62085 8.29191 0.62085 12.0169 0.62085 12.0169C0.62085 12.0169 0.62085 15.7419 1.09585 17.5294C1.35835 18.5169 2.12918 19.2586 3.10835 19.5211C4.88335 20.0002 12 20.0002 12 20.0002C12 20.0002 19.1167 20.0002 20.8917 19.5211C21.8708 19.2586 22.6417 18.5127 22.9042 17.5294C23.3792 15.7419 23.3792 12.0169 23.3792 12.0169C23.3792 12.0169 23.3792 8.29191 22.9042 6.50441ZM9.67502 15.4002V8.63358L15.6208 12.0169L9.67502 15.4002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_8186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube-logo.815ef4c669c6fe2f00bf3404c589a5af.svg";
export { ForwardRef as ReactComponent };